import { ClientLanguageTestSubmission } from '../../lib/types/models/language-test/client-language-test-submission'
import { WithSectionNavigationContext } from '../../lib/types/models/language-test/language-test-submission'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const createLanguageTestSubmission = (enrollmentId: number) => {
  return restApiClient
    .url(constructApiUrl(API.languageTest.createSubmission.url, { id: enrollmentId }))
    .post<WithSectionNavigationContext<ClientLanguageTestSubmission>>()
}
